import Vue from 'vue';
const SucursalVirtuallInstance = new Vue();
export default SucursalVirtuallInstance;
